import axios from 'axios';
import { config } from '../constants/config'

export const extractBucketNameAndObjectKey = (url) => {
  const urlParts = url.split('/');
  const bucketName = urlParts[2].split('.')[0]; // Extracts 'aai-api' from 'aai-api.s3.us-west-1.amazonaws.com'
  const objectKey = urlParts.slice(3).join('/'); // Joins the rest of the parts back into the object key

  return { bucketName, objectKey };
}

function decodeHTMLEntities(text) {
  const entities = {
    '&#x2F;': '/',
    '&amp;': '&',
    '&#x3A;': ':'
    // Add more entities if needed
  };

  return text.replace(/&#x2F;|&amp;|&#x3A;/g, match => entities[match]);
}
export const fetchUserSignedUrlPath = async (userId, urlPath) => {
  // Split the URL to extract folderName and fileName
  console.log('fetchUserSignedUrlPath called with userId:', userId, 'urlPath:', urlPath);

  let decodeUrlPath = decodeHTMLEntities(urlPath);
  console.log('Decoded URL path:', decodeUrlPath);

  // Parse the URL to extract components
  const parts = decodeUrlPath.split('/');
  console.log('URL parts:', parts);

  // Check if this is a voice actor profile image URL, book creator profile image URL, administrator profile image URL, or character avatar URL
  const isVoiceActorProfileImage = parts.includes('aai-actors') && parts.includes('profile-img');
  const isBookCreatorProfileImage = parts.includes('aai-users') && parts.includes('book-creator') && parts.includes('profile-img');
  const isAdminProfileImage = parts.includes('aai-users') && parts.includes('administrators') && parts.includes('profile-img');
  const isCharacterAvatarImage = parts.includes('act-characters') && parts.includes('avatar');
  const isVariationAudio = parts.includes('act-variations');

  console.log('Is voice actor profile image:', isVoiceActorProfileImage);
  console.log('Is book creator profile image:', isBookCreatorProfileImage);
  console.log('Is administrator profile image:', isAdminProfileImage);
  console.log('Is character avatar image:', isCharacterAvatarImage);
  console.log('Is variation audio:', isVariationAudio);

  if (isVoiceActorProfileImage) {
    // For voice actor profile images, we need to handle the URL differently
    const fileName = parts.pop(); // Get the filename (last part)
    const folderName = parts.pop(); // Get the folder name (profile-img)
    const actorId = parts.pop(); // Get the actor ID

    console.log('Voice actor profile image details:');
    console.log('fileName:', fileName);
    console.log('folderName:', folderName);
    console.log('actorId:', actorId);

    try {
      // Make server call using FOLDER requestType which is supported by the server
      // For voice actor profile images, we'll still pass all the parameters but use FOLDER requestType
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        actorId: actorId,  // This will be ignored by the server but we keep it for documentation
        folderName: `aai-actors/${actorId}/${folderName}`,  // Construct the full path
        fileName: fileName
      });

      console.log('Received signed URL for voice actor profile image:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url for voice actor profile image:', decodeUrlPath, 'Error:', error);
      return null;
    }
  } else if (isBookCreatorProfileImage) {
    // For book creator profile images, we need to handle the URL differently
    const fileName = parts.pop(); // Get the filename (last part)
    const folderName = parts.pop(); // Get the folder name (profile-img)
    const creatorId = parts.pop(); // Get the creator ID
    const creatorType = parts.pop(); // Get 'book-creator'
    const userFolder = parts.pop(); // Get 'aai-users'

    console.log('Book creator profile image details:');
    console.log('fileName:', fileName);
    console.log('folderName:', folderName);
    console.log('creatorId:', creatorId);
    console.log('creatorType:', creatorType);
    console.log('userFolder:', userFolder);

    try {
      // Make server call using FOLDER requestType which is supported by the server
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        folderName: `book-creator/${creatorId}/${folderName}`,
        fileName: fileName
      });

      console.log('Received signed URL for book creator profile image:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url for book creator profile image:', decodeUrlPath, 'Error:', error);
      return null;
    }
  } else if (isAdminProfileImage) {
    // For administrator profile images, we need to handle the URL differently
    const fileName = parts.pop(); // Get the filename (last part)
    const folderName = parts.pop(); // Get the folder name (profile-img)
    const adminId = parts.pop(); // Get the admin ID
    const adminType = parts.pop(); // Get 'administrators'
    const userFolder = parts.pop(); // Get 'aai-users'

    console.log('Administrator profile image details:');
    console.log('fileName:', fileName);
    console.log('folderName:', folderName);
    console.log('adminId:', adminId);
    console.log('adminType:', adminType);
    console.log('userFolder:', userFolder);

    try {
      // Make server call using FOLDER requestType which is supported by the server
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        folderName: `administrators/${adminId}/${folderName}`,
        fileName: fileName
      });

      console.log('Received signed URL for administrator profile image:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url for administrator profile image:', decodeUrlPath, 'Error:', error);
      return null;
    }
  } else if (isCharacterAvatarImage) {
    // For character avatar images, we need to handle the URL differently
    const fileName = parts.pop(); // Get the filename (last part)
    const folderName = parts.pop(); // Get the folder name (avatar)
    const characterId = parts.pop(); // Get the character ID
    const portfolioFolder = parts.pop(); // Get the portfolio folder (act-portfolios)
    const portfolioId = parts.pop(); // Get the portfolio ID
    const actorFolder = parts.pop(); // Get the actor folder (aai-actors)
    const actorId = parts.pop(); // Get the actor ID

    console.log('Character avatar image details:');
    console.log('fileName:', fileName);
    console.log('folderName:', folderName);
    console.log('characterId:', characterId);
    console.log('portfolioId:', portfolioId);
    console.log('actorId:', actorId);

    try {
      // Make server call using FOLDER requestType which is supported by the server
      // For character avatar images, we'll construct the full path
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        folderName: `aai-actors/${actorId}/act-portfolios/${portfolioId}/act-characters/${characterId}/${folderName}`,
        fileName: fileName
      });

      console.log('Received signed URL for character avatar image:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url for character avatar image:', decodeUrlPath, 'Error:', error);
      return null;
    }
  } else if (isVariationAudio) {
    const fileName = parts.pop(); // Get the filename (last part)
    const variationId = parts.pop(); // Get the variation ID
    const variationsFolder = parts.pop(); // Get the variations folder (act-variations)
    const characterId = parts.pop(); // Get the character ID
    const characterFolder = parts.pop(); // Get the character folder (act-characters)
    const portfolioId = parts.pop(); // Get the portfolio ID
    const portfolioFolder = parts.pop(); // Get the portfolio folder (act-portfolios)
    const actorId = parts.pop(); // Get the actor ID
    const actorFolder = parts.pop(); // Get the actor folder (aai-actors)

    console.log('Variation audio details:');
    console.log('fileName:', fileName);
    console.log('variationId:', variationId);
    console.log('characterId:', characterId);
    console.log('portfolioId:', portfolioId);
    console.log('actorId:', actorId);
    try {
      // Make server call using FOLDER requestType
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        folderName: `aai-actors/${actorId}/act-portfolios/${portfolioId}/act-characters/${characterId}/act-variations/${variationId}`,
        fileName: fileName
      });

      console.log('Received signed URL for variation audio:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url for variation audio:', decodeUrlPath, 'Error:', error);
      return null;
    }
  } else {
    // Standard handling for other types of URLs
    const fileName = parts.pop(); // Remove and return the last element
    const folderName = parts.pop(); // Remove and return the last element

    console.log('Standard URL details:');
    console.log('fileName:', fileName);
    console.log('folderName:', folderName);

    try {
      // Make server call
      let signedUrl = await fetchSignedUrlByType({
        requestType: 'FOLDER',
        userId: userId,
        folderName: folderName,
        fileName: fileName
      });

      console.log('Received standard signed URL:', signedUrl);
      return signedUrl;
    } catch (error) {
      console.error('Failed to get signed url:', decodeUrlPath, 'Error:', error);
      return null; // Return null or handle the error as appropriate
    }
  }
}

export const fetchSignedUrlFromAudioBookDataPathUtil = async (userId, urlPath) => {
  // Split the URL to extract folderName and fileName

  let decodeUrlPath = decodeHTMLEntities(urlPath)

  const parts = decodeUrlPath.split('/');
  const fileName = parts.pop(); // Remove and return the last element
  const folderName = parts.pop(); // Remove and return the last element
  const bookUuid = parts.pop(); // Remove and return the last element

  try {
    // Make server call
    let signedUrl = await fetchSignedUrlByType({
      requestType: 'AUDIO_BOOK_GET_DATA',
      userId: userId,
      bookUuid: bookUuid,
      folderName: folderName,
      fileName: fileName
    });
    return signedUrl;
  } catch (error) {
    console.error('Failed to get signed url:', decodeUrlPath, 'Error:', error);
    return null; // Return null or handle the error as appropriate
  }
}

export const fetchSignedUrlByType = async (fetchByType) => {
  try {
    const response = await axios.post(`${config.API_GET_SIGNED_URL_BY_TYPE}`, fetchByType);

    console.log('Signed URL:', response.data.signedUrl);
    return response.data.signedUrl;
  } catch (error) {
    console.error('Error fetching signed URL:', error);
  }
};
